import { Paper, Button } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import FunctionsContext from './FunctionsContext';
import IWPPWorkflowForm from './IWPPWorkflowForm';

const Container = styled.div`
    display:flex;
    flex-direction:column;
    align-items:space-between;
    justify-content:space-between;
    padding-top:10px;
    padding-bottom:40px;
`;

const ContainerHeader = styled.div`
    width:100%;
    color: rgba(0, 0, 0, 0.87);
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.25px;
    line-height: 24px;
    text-align: left;
    padding:20px;
    display:flex;
    align-items:center;
    justify-content:space-between;
`;

const ContainerSteps = styled.div`
width:95%;
`;


const ContainerSubHeader = styled.div`
    width:100%;
    color: rgba(0, 0, 0, 0.87);
    font-family: Roboto;
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 0.25px;
    text-align: left;
    padding-left:0px;
    padding-bottom:10px;

`;


const OuterContainer = styled.div`
    display:flex;
    width:100%
    justify-content:center;
    padding-top:40px;
`;

class IWPPWorkflow
 extends React.Component{
    static contextType = FunctionsContext;
    render(){
        return (
                <OuterContainer>
                    <Paper>
                    <Container>
                    <ContainerHeader>
                        <div>
                            <ContainerSubHeader>
                                IWPP Deviation Workflow
                            </ContainerSubHeader>
                        </div>
                      {!this.context.editingIWPPApprovers &&  <Button color="primary" onClick={() => this.context.editIWPPApprovers(true) }>Edit</Button>}
                    </ContainerHeader>
                    <ContainerSteps>                   
                        <>
                            <IWPPWorkflowForm                                 
                                isGbu={false} 
                                context={this.context}  
                                initialValues={ {workflowSteps:this.context.functions.selectedFunctionDetails.approversFormValues} } 
                            />
                            </>
                  
                    </ContainerSteps>
                </Container>
                    </Paper>
                </OuterContainer>
        );

    }

}

export default IWPPWorkflow;